
 export const PayloadCreator = async(type, title, information) => {
    const result = {
        type: type,
        title: title,
        information: information
    }

    return result;
 }